import { HttpClient } from '@angular/common/http';
import { Subject, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngx-translate/core";
var LanguageService = /** @class */ (function () {
    function LanguageService(http, translateSrv) {
        this.http = http;
        this.translateSrv = translateSrv;
        this.languageChanged = new Subject();
        this.baseUrl = environment.apiUrl + 'languages';
    }
    LanguageService.prototype.getList = function () {
        return this.http.get(this.baseUrl);
    };
    LanguageService.prototype.setCurrentLanguage = function (selLanguage) {
        var _this = this;
        if (selLanguage == null) {
            selLanguage = this.translateSrv.getBrowserLang();
        }
        if (selLanguage !== this.selectedLang) {
            return this.translateSrv.use(selLanguage)
                .pipe(map(function () {
                _this.selectedLang = selLanguage;
                _this.languageChanged.next(selLanguage);
            }));
        }
        return of(null);
    };
    LanguageService.prototype.getCurrentLanguageCode = function () {
        return this.selectedLang || this.translateSrv.getBrowserLang();
    };
    LanguageService.ngInjectableDef = i0.defineInjectable({ factory: function LanguageService_Factory() { return new LanguageService(i0.inject(i1.HttpClient), i0.inject(i2.TranslateService)); }, token: LanguageService, providedIn: "root" });
    return LanguageService;
}());
export { LanguageService };
